import { I18nModel } from 'src/context/i18n/I18nModel';
import { Product } from 'src/pages/payments/domain';

export function handleSendWhapp(code: string | null, teamName: string | null, i18n: I18nModel): void {
  if (!code || !teamName) return;
  const shareUrl = `https://wa.me/?text=${i18n
    .t('pages.teams.management.instructions', { code, teamName })
    .replaceAll('\n', '%0a')}`;
  window.open(shareUrl, '_blank');
  return;
}

export function handleSendWhappPayment(product: Product, i18n: I18nModel): void {
  const link = product.link ?? '';
  const name = product.name;
  const shareUrl = `https://wa.me/?text=${i18n
    .t('pages.subscriptions.instructions', { link, name })
    .replaceAll('\n', '%0a')}`;
  window.open(shareUrl, '_blank');
  return;
}

export async function downloadVideo(videoUrl: string | null): Promise<void> {
  if (!videoUrl) return;
  const res = await fetch(videoUrl);
  const file = await res.blob();

  const tempUrl = URL.createObjectURL(file);
  const aTag = document.createElement('a');
  aTag.href = tempUrl;
  aTag.download = videoUrl.replace(/^.*[\\/]/, '');
  document.body.appendChild(aTag);
  aTag.click();
  URL.revokeObjectURL(tempUrl);
  aTag.remove();
}

export function generateAgeGroupOptions() {
  const options = [];

  // Start from 8 (for U8) up to 23 (for U23)
  for (let age = 8; age <= 23; age++) {
    options.push({ label: `U${age}`, id: `U${age}` });

    // Add U18+ option right after U18
    if (age === 18) {
      options.push({ label: 'U18+', id: 'U18+' });
    }
  }

  // Append the "Senior" option
  options.push({ label: 'Senior', id: 'Senior' });

  return options;
}

export const generateTeamCountOptions = (totalTeams: number) => {
  const maxTeams = Math.min(16, totalTeams);
  const effectiveMax = maxTeams % 2 === 0 ? maxTeams : maxTeams - 1;

  const options = [];
  for (let i = 2; i <= effectiveMax; i += 2) {
    options.push({
      id: i.toString(),
      label: i.toString(),
    });
  }
  return options;
};
